<!-- Sidebar -->
<ng-container *transloco="let t">
    <div
    [ngClass]="{'active': isToggled}"
    class="settings-sidebar bg-white box-shadow"
    [class.component-dark-theme]="themeService.isDark()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
    >
        <div class="settings-header bg-gray d-flex align-items-center justify-content-between">
            <div>
                <h5 class="m-0">
                    {{t('configuration-panel')}}
                </h5>
            </div>
            <div>
                <ng-container *ngIf="!themeService.isDark()">
                    <img src="assets/images/icono-intrust-security-ciberseguridad-claro.png" alt="logo-icon" width="40%" height="40%">
                </ng-container>
                <ng-container *ngIf="themeService.isDark()">
                    <img src="assets/images/icono-intrust-security-ciberseguridad-oscuro.png" alt="logo-icon" width="40%" height="40%">
                </ng-container>
            </div>
        </div>
        <ng-scrollbar visibility="hover">
            <div class="settings-body">
                <div class="p-20">
                    <span class="d-block mb-12 fw-medium">
                        {{t('rtl-mode')}}
                    </span>
                    <button
                        (click)="toggleRTLEnabledTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isRTLEnabled()"
                    >
                    </button>
                </div>
                <mat-divider></mat-divider>
                <div class="p-20">
                    <span class="d-block mb-12 fw-medium">
                        {{t('dark-mode')}}
                    </span>
                    <button
                        (click)="toggleTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isDark()"
                    >
                    </button>
                </div>
                <mat-divider></mat-divider>
                <div class="p-20">
                    <span class="d-block mb-12 fw-medium">
                        {{t('only-sidebar-dark')}}
                    </span>
                    <button
                        (click)="toggleSidebarTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isSidebarDark()"
                    >
                    </button>
                </div>
                <mat-divider></mat-divider>
                <div class="p-20">
                    <span class="d-block mb-12 fw-medium">
                        {{t('only-header-dark')}}
                    </span>
                    <button
                        (click)="toggleHeaderTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isHeaderDark()"
                    >
                    </button>
                </div>
                <mat-divider></mat-divider>
                <div class="p-20">
                    <span class="d-block mb-12 fw-medium">
                        {{t('right-sidebar')}}
                    </span>
                    <button
                        (click)="toggleRightSidebarTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isRightSidebar()"
                    >
                    </button>
                </div>
                <mat-divider></mat-divider>
                <div class="p-20 hide-sidebar">
                    <span class="d-block mb-12 fw-medium">
                        {{t('hide-sidebar')}}
                    </span>
                    <button
                        (click)="toggleHideSidebarTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isHideSidebar()"
                    >
                    </button>
                </div>
                <mat-divider></mat-divider>
                <div class="p-20">
                    <span class="d-block mb-12 fw-medium">
                        {{t('borderd-card')}}
                    </span>
                    <button
                        (click)="toggleCardBorderTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isCardBorder()"
                    >
                    </button>
                </div>
                <mat-divider></mat-divider>
                <div class="p-20">
                    <span class="d-block mb-12 fw-medium">
                        {{t('card-border-radius')}}
                    </span>
                    <button
                        (click)="toggleCardBorderRadiusTheme()"
                        class="switch-btn"
                        [class.active]="themeService.isCardBorderRadius()"
                    >
                    </button>
                </div>
            </div>
        </ng-scrollbar>
    </div>
</ng-container>
<!-- Settings Button -->
<button
    mat-fab
    (click)="toggle()"
    class="altair settings-btn"
    [ngClass]="{'active': isToggled}"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-icon>settings</mat-icon>
</button>
